import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WidgetBox from '@wix/da-gruser-shared/pkg/components/WidgetBox';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import usePage from '@wix/da-gruser-shared/pkg/hooks/usePage';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import ExhibitionistStrip from '../ExhibitionistStrip';
import ExhibitionistGrid from '../ExhibitionistGrid';
import ExhibitionistEmpty from '../ExhibitionistEmpty';
import { GallectionType, gallectionTypeToResourceType } from '../../../types/gallection';
import FavouritesLabel from '../_partials/FavouritesLabel';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import ConditionalWrapper from '@wix/da-ds/pkg/ConditionalWrapper/ConditionalWrapper';
import WidgetPaywall from '../../lego/WidgetPaywall';
import { ExhibitionistViewMode } from '../ExhibitionistConfigPopover/types';
import ExhibitionistSlideshow from '../ExhibitionistSlideshow';
import DuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID } from '../consts';
import { useExhibitionistType } from '../hooks';
import { ExhibitionistWidgetType } from '../types';
import { useShowCoreUpsell } from '../../hooks/useShowCoreUpsell';
import ExhibitionistGrid3x3 from '../ExhibitionistGrid3x3/ExhibitionistGrid3x3';
import s from './ExhibitionistBox.scss';
const ExhibitionistBox = ({ moduleId, widgetBoxProps })=>{
    const { t } = useTranslation();
    const exhibitionistType = useExhibitionistType();
    const isMobile = useContext(MobileContext);
    const gruserPage = usePage();
    const { moduleData } = useModuleData(moduleId);
    const { title, sourceType, seeAllUrl, premiumFolderData, deviations, folderId, viewMode } = moduleData;
    const isEmpty = deviations.length === 0;
    const showCoreUpsell = useShowCoreUpsell(moduleId) && exhibitionistType === ExhibitionistWidgetType.STRIP_SHORT;
    const renderContent = ()=>{
        if (isEmpty) {
            return /*#__PURE__*/ React.createElement(ExhibitionistEmpty, {
                moduleId: moduleId
            });
        }
        let content;
        if (isMobile) {
            content = /*#__PURE__*/ React.createElement(ExhibitionistGrid3x3, {
                moduleId: moduleId
            });
        } else if (exhibitionistType === ExhibitionistWidgetType.TALL) {
            const isSlideshow = viewMode === ExhibitionistViewMode.SLIDESHOW;
            content = isSlideshow ? /*#__PURE__*/ React.createElement(ExhibitionistSlideshow, {
                moduleId: moduleId
            }) : /*#__PURE__*/ React.createElement(ExhibitionistGrid, {
                moduleId: moduleId
            });
        } else {
            content = /*#__PURE__*/ React.createElement(ExhibitionistStrip, {
                moduleId: moduleId
            });
        }
        return /*#__PURE__*/ React.createElement(DuperbrowseContext, {
            streamId: EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID,
            deviations: deviations
        }, content);
    };
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            itemid: folderId || undefined,
            typeid: gallectionTypeToResourceType(sourceType)
        }
    }, /*#__PURE__*/ React.createElement(WidgetBox, _object_spread({
        headerClassName: s['header'],
        header: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
            premiumFolderData: premiumFolderData,
            size: IconSize.COMPACT,
            className: s['premium-folder-icon']
        }), title || t(`widgets.exhibitionist.source.${sourceType}`)),
        headerExtras: sourceType === GallectionType.COLLECTION ? /*#__PURE__*/ React.createElement(FavouritesLabel, null) : undefined,
        seeAllUrl: seeAllUrl,
        moduleId: moduleId
    }, widgetBoxProps), /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: showCoreUpsell,
        wrap: (child)=>/*#__PURE__*/ React.createElement(WidgetPaywall, {
                lockedClassName: s['widget-paywall-locked'],
                title: t('widgets.exhibitionist.coreOnly.paywall.title'),
                subtitle: t('widgets.exhibitionist.coreOnly.paywall.subtitle'),
                buttonAlignment: "horizontal",
                previewReferral: (gruserPage === null || gruserPage === void 0 ? void 0 : gruserPage.name) === 'deviation' ? ReferralType.DEVIATION_WIDGET_PAYWALL_PREVIEW : ReferralType.WIDGET_PAYWALL_PREVIEW,
                lockedReferral: (gruserPage === null || gruserPage === void 0 ? void 0 : gruserPage.name) === 'deviation' ? ReferralType.DEVIATION_WIDGET_PAYWALL_OVERLAY : ReferralType.WIDGET_PAYWALL_OVERLAY
            }, child)
    }, renderContent())));
};
ExhibitionistBox.displayName = 'ExhibitionistBox';
export default ExhibitionistBox;

//# sourceMappingURL=ExhibitionistBox.js.map